var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticStyle:{"color":"red","white-space":"pre-wrap","font-size":"12px","margin":"15px"}},[_vm._v(" * 收益统计数据仅供参考，不含手续费，请以实际到账金额为准。 ")])}
var staticRenderFns = []

export { render, staticRenderFns }